import { doGet, doPost } from 'system/httpHelper';
import { mapSelectionToApi, MappingError } from 'utils/queryMappingLayer';
import { runStart, runSuccess, runFail } from './actions';

function serializeError(e) {
  if (e instanceof MappingError) {
    return { message: e.message, code: e.code, meta: e.meta || null };
  }
  return { message: e?.message || 'Unknown error', code: 'UNKNOWN' };
}

function mergeNormalized(results) {
  if (!Array.isArray(results) || results.length === 0) {
    return { chartType: 'lines', data: [] };
  }
  if (results.length === 1) return results[0];

  const firstType = results[0].chartType;
  const same = results.every((r) => r.chartType === firstType);
  if (!same) return results; // mixed types

  return { chartType: firstType, data: results.flatMap((r) => r.data || []) };
}

export default function runBuilderQuery(selection) {
  return async (dispatch) => {
    dispatch(runStart(selection));

    let calls;
    try {
      calls = mapSelectionToApi(selection);
    } catch (e) {
      dispatch(runFail(serializeError(e)));
      return;
    }

    try {
      const results = await Promise.all(
        calls.map(async (call) => {
          const url =
            call.method === 'GET' && call.params && Object.keys(call.params).length
              ? `${call.url}?${new URLSearchParams(call.params)}`
              : call.url;

          const raw =
            call.method === 'POST' ? await doPost(url, call.body || {}) : await doGet(url);

          return call.normalizer(raw, call);
        }),
      );

      dispatch(runSuccess(mergeNormalized(results)));
    } catch (err) {
      dispatch(runFail(serializeError(err)));
    }
  };
}
